import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  SjfTargetDateGrid,
} from '../../components'

const Styles = require('./TargetDateSeries.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeries extends Component {
  render() {
    return <div styleName='main-grid'>
      {
        container.helmet(
          'Target date funds',
          config.app.description,
          config.app.domain + config.routes.targetDateFunds
        )
      }
      <SjfTargetDateGrid/>
    </div>
  }
}
